<template>
  <el-table :data="list" border class="product" height="100%" v-loading="loading">
    <el-table-column
      type="index"
      width="50"
      align="center"
    ></el-table-column>
    <el-table-column align="center" label="产品信息">
      <div slot-scope="{row}" class="f-c-c">
        <el-popover placement="right" width="280" trigger="hover">
          <el-image :src="row.imgUrl" fit="cover" />
          <el-image slot="reference" :src="row.imgUrl" fit="cover" class="stock-img" />
        </el-popover>
        <div style="margin-left: 10px;text-align:left">
          <el-tooltip effect="light" :content="row.productName" placement="top">
            <div class="ellipsis" style="width: 200px" v-if="row.productName">标题: {{row.productName}}</div>
          </el-tooltip>
          <div v-if="row.takeDownType === 2">SKU: {{row.skuCode}}</div>
          <div v-else>SPU: {{row.spuCode}}</div>
        </div>
      </div>
    </el-table-column>
    <el-table-column align="center" label="下架时间">
      <template slot-scope="{row}">
        {{ row.takeDownTime | dateFormat }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="人员信息">
      <template slot-scope="scope">
        创建人: {{ scope.row.creater }}
      </template>
    </el-table-column>
    <el-table-column label="时间信息" align="center">
      <template slot-scope="scope">
        <div>创建时间: {{ scope.row.createDate | dateFormat }}</div>
        <div>发送时间: {{ scope.row.sendTime | dateFormat }}</div>
      </template>
    </el-table-column>
    <!-- <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <el-button
          @click="editRow(scope.row)"
          type="text"
          size="small"
          style="margin-right: 8px"
          >编辑</el-button
        >
        <el-popconfirm
          title="确定删除此条数据吗"
          icon-color="red"
          @confirm="deleteRow(scope.row)"
        >
          <el-button
            slot="reference"
            type="text"
            size="small"
            style="color: red"
            >删除</el-button
          >
        </el-popconfirm>
      </template>
    </el-table-column> -->
  </el-table>
</template>

<script>
// import API from "@/api"
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.product{
  .stock-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f5f7fa;
    user-select: none;
    cursor: pointer;
  }
}
</style>